import type { IconData } from '@stacksjs/iconify-core'

export const sd4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGo1QMTd8m\"><path fill-opacity=\".7\" d=\"M0 0h682.7v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGo1QMTd8m)\" transform=\"scale(.9375)\"><path fill=\"#000001\" d=\"M0 341.3h1024V512H0z\"/><path fill=\"#fff\" d=\"M0 170.6h1024v170.7H0z\"/><path fill=\"red\" d=\"M0 0h1024.8v170.7H0z\"/><path fill=\"#009a00\" d=\"M0 0v512l341.3-256z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default sd4x3
